import { mapActions } from 'vuex';
import { loadScript } from '@/utils/helpers';
/*
  Use this component as <captcha :key="parentVar"></captcha>
  and update var on error, so it rerenders properly.
 */
export default {
  data() {
    return {
      key: '',
    };
  },
  computed: {
    styleModifiers() {
      return {
        transform: 'scale(0.95)',
      };
    },
  },
  methods: {
    ...mapActions('user', ['getCaptchaSiteKey']),
    onSuccess(value) {
      this.$emit('input', value);
    },
    onExpired() {
      this.$emit('input', null)
    }
  },
  mounted() {
    const url = 'https://www.google.com/recaptcha/api.js';
    loadScript(url, 'grecaptcha')
      .then((grecaptcha) => {
        this.getCaptchaSiteKey()
          .then((data) => {
            this.key = data;
            grecaptcha.ready(() => {
              grecaptcha.render(this.$refs.captcha, {
                sitekey: this.key,
                callback: this.onSuccess,
                ['expired-callback']: this.onExpired,
              });
            });
          });
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/captcha/captcha.js